import { brandSecondary, darkGrayFontColor, nameCircles, titles } from '../../../../web/styles/colors';
import { CssSelectors, baseStyleSheet } from '../../../../web/styles/styles';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	bodyCenter: {
		display: 'flex',
		gap: '2rem',
	},
	content: {
		color: darkGrayFontColor,
		fontSize: '1rem',
		...CssSelectors.allDescendants(
			{
				...baseStyleSheet.fontBold,
			},
			'strong'
		),
	},
	contentSmall: {
		fontSize: '0.8rem',
	},
	footer: {
		...CssSelectors.allChildren(
			{
				marginLeft: '0.5rem',
			},
			':not(:first-child)'
		),
		alignItems: 'center',
		borderTop: `1px solid ${nameCircles}`,
		display: 'flex',
		justifyContent: 'flex-end',
		marginTop: 20,
		padding: `2rem 0`,
	},
	headerDisplayName: {
		marginBottom: '0.75rem',
	},
	headerLabel: {
		color: titles,
		fontSize: '1.125rem',
	},
	root: {
		...CssSelectors.allDescendants({
			boxSizing: 'border-box',
		}),
		boxSizing: 'border-box',
		margin: '0 auto',
		maxWidth: 1200,
		padding: '2rem',
	},
	sectionCustomDesign: {
		display: 'flex',
		flex: 2,
		flexDirection: 'column',
	},
	sectionCustomDesignHeader: {
		alignItems: 'baseline',
		display: 'flex',
	},
	sectionCustomDesignHeaderLabel: {
		flex: 1,
	},
	sectionMessage: {
		flex: 1,
		...CssSelectors.allDescendants(
			{
				border: `1px dashed ${brandSecondary}`,
				borderRadius: 3,
				boxSizing: 'border-box',
				fontSize: 14,
				padding: '1px 5px',
			},
			'span[data-placeholder="true"]'
		),
	},
	templateImage: {
		display: 'block',
		maxHeight: '22rem',
		maxWidth: '20rem',
	},
	templateImageContainer: {
		alignItems: 'center',
		background: 'rgb(249, 249, 249)',
		border: '1px dashed rgb(204, 204, 204)',
		borderRadius: '0.5rem',
		display: 'flex',
		flexDirection: 'column',
		height: '24rem',
		justifyContent: 'center',
		webkitBoxAlign: 'center',
		webkitBoxDirection: 'normal',
		webkitBoxOrient: 'vertical',
		webkitBoxPack: 'center',
		width: '100%',
	},
});
